import { iVue } from "../type";
import forcechangepassword from "./forcechangepassword.vue";

export default {
  install(Vue: iVue) {
    Vue.addRoutes({
      path: "/force-change-password",
      component: forcechangepassword,
      beforeEnter: (to: any, from: any, next: any) => {
        const hasToken = localStorage.getItem("token");
        if (!hasToken) {
          next("/");
        } else {
          next();
        }
      },
    });
  },
};
